<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps<{ error: NuxtError }>();

const handleError = () => clearError({ redirect: '/' });
</script>

<template>
  <div class="min-h-screen flex flex-col bg-[var(--color-cream)]">
    <Header />

    <main class="flex-1 flex flex-col items-center justify-center px-6 text-center">
      <div class="relative">
        <!-- Decorative blobs -->
        <div class="absolute -top-16 -left-16 w-48 h-48 bg-[var(--color-peach)]/10 rounded-full blur-3xl pointer-events-none" />
        <div class="absolute -bottom-8 -right-12 w-36 h-36 bg-primary-100/40 rounded-full blur-2xl pointer-events-none" />

        <div class="relative">
          <p class="text-8xl font-extrabold text-[var(--color-charcoal)]/10">
            {{ error.status }}
          </p>
          <h1 class="mt-4 text-2xl md:text-3xl font-bold text-[var(--color-charcoal)]">
            {{ error.status === 404 ? 'Siden blev ikke fundet' : 'Noget gik galt' }}
          </h1>
          <p class="mt-3 text-[var(--color-charcoal)]/60 max-w-md mx-auto">
            {{ error.status === 404 ? 'Den side du leder efter, findes ikke — måske er den flyttet eller slettet.' : 'Der skete en uventet fejl. Prøv at genindlæse siden.' }}
          </p>
          <UButton
            label="Tilbage til forsiden"
            color="primary"
            class="mt-8 rounded-full px-8"
            size="lg"
            @click="handleError"
          />
        </div>
      </div>
    </main>
  </div>
</template>
